import type { DashboardByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDashboardByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDashboardByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDashboardByIdArgs = {
  id: string;
};

export const useGetDashboardById = createQueryHook<
  UseGetDashboardByIdArgs,
  DashboardByIdResponseRow | null,
  GetDashboardByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.dashboard.dashboardById.queryOptions({ id }),
  // The legacy query root is the singular `dashboard_by_pk` (object | null);
  // the tRPC procedure already returns the unwrapped object | null.
  mapTrpcDataToGraphQL: (data) => ({ dashboard_by_pk: data }),
  graphqlDocument: GetDashboardByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
  // Co-mounted with the dashboards list under OverallDashboard.
  graphqlFetchPolicy: 'cache-first',
});
